import { Screen } from '~/screens/groups/new';

export const GroupsNew: React.FC = () => <Screen />;
